import { useQuery } from '@apollo/client';
import { gql } from '__generated__';
import { PrintSessionType } from '__generated__/graphql';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import DataTable from 'components/DataTable';
import ErrorMessage from 'components/ErrorMessage';
import LoadingIndicator from 'components/LoadingIndicator';

const PRINT_SESSIONS_QUERY = gql(`
  query PrintSessions($departmentId: ID!, $limit: Int, $cursor: ID) {
    department(id: $departmentId) {
      id
      printSessions(limit: $limit, cursor: $cursor) {
        nodes {
          id
          name
          status
          createdAt
        }
        pageInfo {
          cursor
          totalCount
          hasNextPage
        }
      }
    }
  }
`);

const DepartmentPrintSessionsPage: FC = () => {
  const { departmentId } = useParams<{ departmentId: string }>();

  const { loading, error, data, refetch, fetchMore } = useQuery(PRINT_SESSIONS_QUERY, {
    variables: {
      departmentId: departmentId as string,
      limit: 20,
    },
  });
  if (loading) return <LoadingIndicator />;

  if (error || !data) return <ErrorMessage error={error} refetch={refetch} />;

  const printSessions = data.department.printSessions.nodes;
  const pageInfo = data.department.printSessions.pageInfo;

  return (
    <DataTable
      data={printSessions as PrintSessionType[]}
      onClick={printSession => window.open(`/print-sessions/${printSession.id}`, '_blank')}
      columns={[
        {
          label: 'Name',
          fieldName: 'name',
        },
        {
          label: 'Status',
          fieldName: 'status',
        },
        {
          label: 'Created At',
          fieldName: 'createdAt',
        },
      ]}
      paginationLoading={loading}
      hasNextPage={pageInfo.hasNextPage as boolean}
      onLoadMore={() =>
        fetchMore({
          variables: {
            cursor: pageInfo.cursor,
          },
        })
      }
    />
  );
};

export default DepartmentPrintSessionsPage;
